import { useTranslation } from 'react-i18next';
import { Text } from 'shell/components';

const SubmissionSelectionCount = ({ count, sx }) => {
    const { t } = useTranslation('assignment');

    if (!count) return null;

    return (
        <Text aria-live={'polite'} sx={{ whiteSpace: 'nowrap', ...sx }} color={'primary'} weight={'medium'}>
            {t('submission.selected-count', '{{count}} Submission(s) Selected', { count })}
        </Text>
    );
};

export default SubmissionSelectionCount;
